'use client';
import { Box, DsmColor, Grid, GridColumn, Carousel, CarouselSlide, Typography, omitText } from '@kohler-dsm-library/kohler-core';
import { ArrowRightIcon, ArrowLeftIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './GlobalBanner.module.css.mjs';

const GlobalBanner = ({
  content,
  carouselControlProps
}) => {
  return /* @__PURE__ */ React.createElement(Box, { className: clsx(classes.globalBanner, "kohler-global-banner-root"), backgroundColor: DsmColor.BackgroundPrimary }, /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, null, /* @__PURE__ */ React.createElement(
    Carousel,
    {
      maxWidth: "min(calc(700px + 2 * 30px), 100%)",
      withControls: content.length > 1,
      includeGapInSize: false,
      loop: true,
      draggable: content.length > 1,
      style: { justifySelf: "center" },
      carouselControlProps: { ...carouselControlProps },
      customLeftControl: /* @__PURE__ */ React.createElement(Box, { component: "button", type: "button", display: "flex", textColor: DsmColor.ContentPrimary, "aria-label": "go to previous slide" }, /* @__PURE__ */ React.createElement(ArrowLeftIcon, { withBoundingBox: true, size: "small" })),
      customRightControl: /* @__PURE__ */ React.createElement(Box, { component: "button", type: "button", display: "flex", textColor: DsmColor.ContentPrimary, "aria-label": "go to next slide" }, /* @__PURE__ */ React.createElement(ArrowRightIcon, { withBoundingBox: true, size: "small" }))
    },
    content.map((item, index) => {
      return /* @__PURE__ */ React.createElement(CarouselSlide, { key: `global-banner-${index}`, className: classes.globalBannerSlide }, /* @__PURE__ */ React.createElement(Box, { component: "div", textAlign: "center", maxWidth: 700, paddingInline: 30, marginTop: -1 }, /* @__PURE__ */ React.createElement(Typography, { size: "paragraph-small", textColor: DsmColor.ContentPrimary, component: "span" }, item.message), item.CTA && // eslint-disable-next-line @typescript-eslint/no-explicit-any
      /* @__PURE__ */ React.createElement(
        Typography,
        {
          size: "label-medium-xs",
          whiteSpace: "nowrap",
          textDecoration: "underline",
          textColor: DsmColor.ContentPrimary,
          component: "href" in item.CTA && item.CTA.href ? "a" : "button",
          ...omitText(item.CTA),
          className: classes.inlineLink
        },
        item.CTA.text
      )));
    })
  ))));
};

export { GlobalBanner };
